































































import { defineComponent } from '@vue/composition-api';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import PriceSuggestIcon from '@tt4b/ttam-assets/src/svgs/price-suggest-icon.svg';

const name = 'ttam-bid-strategy-suggest-bid';

export default defineComponent({
  name,
  components: {
    TooltipInfo,
    PriceSuggestIcon,
  },
  props: {
    suggestBid: {
      type: String,
      required: true,
    },
    suggestBidNum: {
      type: Number,
      required: true,
    },
    currencyUnit: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => null,
    },
  },
  setup(props, { emit }) {
    const onRefresh = () => {
      emit('refresh');
    };
    const onApply = () => {
      emit('apply', props.suggestBidNum);
    };
    return {
      PriceSuggestIcon,
      name,
      onRefresh,
      onApply,
    };
  },
});
